import { jsx as _jsx } from "react/jsx-runtime";
import { BaseProvider } from './commons/base-provider/base-provider';
import Router from './components/router/router';
import RouterProvider from './components/router/router-provider';
import { GlobalProvider } from './context/global/global.provider';
import './global.css';
const App = ({ history, auth, country }) => (_jsx(BaseProvider, { children: _jsx(RouterProvider, { history: history, children: _jsx(GlobalProvider, { initialState: { auth, country }, children: _jsx(Router, {}) }, country) }) }));
export default App;
